import icRadiocheckBlue from "../../assets/aaa/light/icons/ic-radiocheck-blue.svg";
import icRadiocheckOrange from "../../assets/aaa/light/icons/ic-radiocheck-orange.svg";
import icAchtung from "../../assets/aaa/light/icons/ic_achtung.svg";
import icAdd from "../../assets/aaa/light/icons/ic_add.svg";
import icAddTransparent from "../../assets/aaa/light/icons/ic_add_transparent.svg";
import icCalender from "../../assets/aaa/light/icons/ic_calendar.svg";
import icChevronUp from "../../assets/aaa/light/icons/ic_chevron_up.svg";
import icChevronDown from "../../assets/aaa/light/icons/ic_chevron_down.svg";
import icChevronDownWhite from "../../assets/aaa/light/icons/ic_chevron_down_white.svg";
import icChevronLeft from "../../assets/aaa/light/icons/ic_chevron_left.svg";
import icChevronLeftOrange from "../../assets/aaa/light/icons/ic_chevron_left_orange.svg";
import icChevronRight from "../../assets/aaa/light/icons/ic_chevron_right.svg";
import icChevronRightWhite from "../../assets/aaa/light/icons/ic_chevron_right_white.svg";
import icClock from "../../assets/aaa/light/icons/ic_clock.svg";
import icClose from "../../assets/aaa/light/icons/ic_close.svg";
import icCoins from "../../assets/aaa/light/icons/ic_coins.svg";
import icDelete from "../../assets/aaa/light/icons/ic_delete.svg";
import icDownload24x24 from "../../assets/aaa/light/icons/ic_download-24x24.svg";
import icDropdownGrey from "../../assets/aaa/light/icons/ic_dropdown-grey.svg";
import icDropdownOrange from "../../assets/aaa/light/icons/ic_dropdown-orange.svg";
import icDropupGrey from "../../assets/aaa/light/icons/ic_dropup-grey.svg";
import icDropupOrange from "../../assets/aaa/light/icons/ic_dropup-orange.svg";
import icEdit from "../../assets/aaa/light/icons/ic_edit.svg";
import icFileBlack from "../../assets/aaa/light/icons/ic_file-black.svg";
import icFileGrey from "../../assets/aaa/light/icons/ic_file-grey.svg";
import icFilter from "../../assets/aaa/light/icons/ic_filter.svg";
import icLink from "../../assets/aaa/light/icons/ic_link.svg";
import icLocation from "../../assets/aaa/light/icons/ic_location.svg";
import icPlus from "../../assets/aaa/light/icons/ic_plus.svg";
import icSubtract from "../../assets/aaa/light/icons/ic_subtract.svg";
import icLogout from "../../assets/aaa/light/icons/ic_logout.svg";
import icMore from "../../assets/aaa/light/icons/ic_more.svg";
import icOpennewtab from "../../assets/aaa/light/icons/ic_opennewtab.svg";
import icPrint24x24 from "../../assets/aaa/light/icons/ic_print-24x24.svg";
import icSearch from "../../assets/aaa/light/icons/ic_search.svg";
import icSwitchesCheckboxOff from "../../assets/aaa/light/icons/ic_switches_checkbox_off.svg";
import icSwitchesCheckboxOn from "../../assets/aaa/light/icons/ic_switches_checkbox_on.svg";
import icSwitchesRadioOff from "../../assets/aaa/light/icons/ic_switches_radio_off.svg";
import icSwitchesRadioOn from "../../assets/aaa/light/icons/ic_switches_radio_on.svg";
import icVisibility from "../../assets/aaa/light/icons/ic_visibility.svg";
import icVisibilityOff from "../../assets/aaa/light/icons/ic_visibility_off.svg";
import icNotification from "../../assets/aaa/light/icons/ic_notification.svg";
import icMessage from "../../assets/aaa/light/icons/ic_message.svg";
import icNoMessage from "../../assets/aaa/light/icons/ic_no-message.svg";
import icTime from "../../assets/aaa/light/icons/ic_time.svg";
import icComment from "../../assets/aaa/light/icons/ic_comment.svg";
import icGoogle from "../../assets/aaa/light/icons/ic_google.svg";
import illuNoNotes from "../../assets/aaa/light/illustrations/illu-no_notes.svg";
import illuNoResults from "../../assets/aaa/light/illustrations/illu-no_results.svg";
import illuPlanet from "../../assets/aaa/light/illustrations/illu-planet.svg";
import headerImage01 from "../../assets/aaa/light/images/header-image-01.jpg";
import headerImage02 from "../../assets/aaa/light/images/header-image-02.jpg";
import headerImage03 from "../../assets/aaa/light/images/header-image-03.jpg";
import headerImage04 from "../../assets/aaa/light/images/header-image-04.jpg";
import logoImage from "../../assets/aaa/light/images/logo.svg";
import icLanguage from "../../assets/aaa/light/icons/ic_language.svg";
import icPin from "../../assets/aaa/light/icons/ic_pin.svg";

export const aaaImages = {
    icRadiocheckBlue,
    icRadiocheckOrange,
    icAchtung,
    icAdd,
    icAddTransparent,
    icCalender,
    icChevronUp,
    icChevronDown,
    icChevronDownWhite,
    icChevronLeft,
    icChevronLeftOrange,
    icChevronRight,
    icChevronRightWhite,
    icClock,
    icClose,
    icCoins,
    icDelete,
    icDownload24x24,
    icDropdown: icDropdownOrange,
    icDropdownGrey,
    icDropdownOrange,
    icDropupGrey,
    icDropupOrange,
    icEdit,
    icFileBlack,
    icFileGrey,
    icFilter,
    icLink,
    icLocation,
    icPlus,
    icSubtract,
    icLogout,
    icMore,
    icOpennewtab,
    icPrint24x24,
    icSearch,
    icSwitchesCheckboxOff,
    icSwitchesCheckboxOn,
    icSwitchesRadioOff,
    icSwitchesRadioOn,
    icVisibility,
    icVisibilityOff,
    icNotification,
    icMessage,
    icNoMessage,
    icTime,
    icComment,
    icGoogle,
    illuNoNotes,
    illuNoResults,
    illuPlanet,
    headerImage01,
    headerImage02,
    headerImage03,
    headerImage04,
    logoImage,
    icLanguage,
    icPin
};
